import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const VotingListPronounced = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.34663 5.62352L3.45448 5.52845L3.50995 5.39581L4.21189 3.7173C4.29859 3.50997 4.50134 3.375 4.72607 3.375C5.03387 3.375 5.2834 3.62453 5.2834 3.93233V5.08973L4.93591 6.74378L4.77762 7.49727H5.54756H6.75019C7.81351 7.49727 8.58982 8.50238 8.32112 9.53118L7.82907 11.4151C7.60595 12.2694 6.74101 12.7888 5.88206 12.5843L1.92453 11.642L1.85314 11.625H1.77975H0.625V7.49727H0.984815H1.22096L1.3981 7.34112L3.34663 5.62352Z"
          stroke={color}
          strokeWidth="1.25"
        />
        <path opacity="0.6" d="M10.5 4L15.5 4" stroke={color} strokeLinecap="round" />
        <path opacity="0.6" d="M11.5 8H14.5" stroke={color} strokeLinecap="round" />
        <path opacity="0.6" d="M11.5 12H15.5" stroke={color} strokeLinecap="round" />
      </svg>
    )
  },
)

export default VotingListPronounced
